module.exports = __webpack_public_path__ + "static/media/guido_rodriguez.8bd3eedd.jpg";